<script>
import {
  orderSummaryOrderDetailProps,
  useOrderSummaryOrderDetail
} from "./mixin";
import ProductCategory from "@/components/organisms/product-category";
import ProductCategoryItemLight from "@/components/organisms/product-category/product-category-item/light/mobile";
import Card from "@/components/molecules/card";
import Accordion from "@/components/molecules/accordion";
import Button from "@/components/atoms/button";

export default {
  name: "OrderDetail",
  components: {
    ProductCategoryItemLight,
    ProductCategory,
    Card,
    Accordion,
    Button
  },
  props: {
    ...orderSummaryOrderDetailProps()
  },
  setup() {
    const { nbArticlesBySection } = useOrderSummaryOrderDetail();
    return { nbArticlesBySection };
  },
  methods: {
    closeAll() {
      for (const section of this.panierBySections) {
        const refName = `category-${section.valeur}`;
        if (
          this.$refs[refName] &&
          this.$refs[refName][0] &&
          typeof this.$refs[refName][0].setOpened === "function"
        ) {
          this.$refs[refName][0].setOpened(false);
        }
      }
    }
  }
};
</script>

<template>
  <div>
    <p class="u-font-secondary u-color-primary u-font-700 u-font-21 u-text-center u-mb-sm">
      Détail de ma commande :<br>{{ nbProduits }} {{ pluralize(nbProduits, 'produit') }}
    </p>
    <p class="u-text-right u-mb-sm u-none u-block@sm">
      <Button
        link
        variant="text-light"
        @click="closeAll()"
      >
        Tout replier
      </Button>
    </p>
    <Accordion ref="accordion">
      <Card
        v-for="section in panierBySections"
        :key="section.valeur"
        radius="md"
        border-color="grey-7"
        class="u-mb-md u-pt-xs u-pb-xs u-pl-sm u-pr-sm"
      >
        <ProductCategory :ref="`category-${section.valeur}`">
          <template #title>
            <p class="u-mb-xs">
              {{ section.libelle }}
              <span class="u-font-15 u-ml-xs">
                ({{ nbArticlesBySection(section) }} {{ pluralize(nbArticlesBySection(section), "produit") }})
              </span>
            </p>
          </template>
          <ProductCategoryItemLight
            v-for="(article, index) in section.articles"
            :key="`${index}-${article.id}`"
            :article="article"
            :cart-context="trackingCodes.LABELGA.AnciennesCommandes"
            :avantages-calcules="avantagesCalcules"
          />
        </ProductCategory>
      </Card>
    </Accordion>
  </div>
</template>
